import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBatteryEmpty: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconBatteryEmpty"><Path fillRule="evenodd" clipRule="evenodd" d="M1 7.5C1 6.11929 2.11929 5 3.5 5H17.5C18.8807 5 20 6.11929 20 7.5V8H21.5C22.3284 8 23 8.67157 23 9.5V14.5C23 15.3284 22.3284 16 21.5 16H20V16.5C20 17.8807 18.8807 19 17.5 19H3.5C2.11929 19 1 17.8807 1 16.5V7.5ZM20 15H21.5C21.7761 15 22 14.7761 22 14.5V9.5C22 9.22386 21.7761 9 21.5 9H20V15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBatteryEmpty;
